import { DateTime } from "luxon";

const LOCALE = "es";

export const formatDate = (date: string) => {
  return (new Date(date)).toLocaleDateString();
}

export const getDate = timestamp => {
  const date = new Date(timestamp * 1000)
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2)
  const day = ("0" + date.getDate()).slice(-2);

  return `${day}/${month}/${year}`
}

export const generateGitHubUrl = (username: string) => {
  return `https://github.com/${username}`;
}

export const getTimeFrom = (dateISO: string) => (
  DateTime
    .fromISO(dateISO, { locale: LOCALE })
    .toRelativeCalendar()
);

/**
 * Return the image url depending on the current environment
 * 
 * @param {string} url
 * @param {boolean} [override=false]
 * @returns {string} url for the image.
**/
export const getImgUrl = (url: string, override = false) => {
  const dev = process.env.NEXT_PUBLIC_ENV === 'development' || override;
  if (dev) {
    return `http://localhost:1337${url}`;
  } else {
    return url;
  }
}
